module.exports = __webpack_public_path__ + "static/media/ymer.5b038a0a.png";